
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'UCLA_Comprehensive_Staging_System_for_Renal_Cancer',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/UCLA_Comprehensive_Staging_System_for_Renal_Cancer.vue